var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 200,
    viewBox: "0 0 192 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_one",
    "data-name": "logo one",
    transform: "translate(17745 7300)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M62,0h68a62,62,0,0,1,62,62v76a62,62,0,0,1-62,62H62A62,62,0,0,1,0,138V62A62,62,0,0,1,62,0Z",
    transform: "translate(-17745 -7300)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sa",
    d: "M38.1-14.762A13.761,13.761,0,0,1,32.922-3.438Q27.745.728,18.847.728a34.629,34.629,0,0,1-15.41-3.2V-12.942a68.687,68.687,0,0,0,9.1,3.357A27.276,27.276,0,0,0,19.7-8.574a8.979,8.979,0,0,0,5.4-1.436,4.906,4.906,0,0,0,1.962-4.226,4.571,4.571,0,0,0-.89-2.811,10.279,10.279,0,0,0-2.447-2.265,58.772,58.772,0,0,0-6.754-3.519,33.387,33.387,0,0,1-7.583-4.55A14.647,14.647,0,0,1,4.044-38.948a13.665,13.665,0,0,1,4.772-11q4.772-4.044,13.225-4.044a40.092,40.092,0,0,1,15.814,3.761l-3.64,8.777a51.672,51.672,0,0,0-7.078-2.427,24.166,24.166,0,0,0-5.723-.688A6.9,6.9,0,0,0,16.8-43.114a4.877,4.877,0,0,0-1.719,3.923,5.659,5.659,0,0,0,2.872,4.772,68.81,68.81,0,0,0,7.159,3.68q7.4,3.559,10.192,7.159A13.956,13.956,0,0,1,38.1-14.762ZM79.636,0h-9.13L67.624-9.494H53.064L50.182,0h-9.13L55.126-40.071H65.47ZM55.187-16.593h10.4l-4.52-14.59q-.485-1.638-.728-2.7Q59.525-30.607,55.187-16.593Z",
    transform: "translate(-17726.117 -7210.728)",
    fill: "#f2dbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bbir",
    d: "M11.728,8.1H8.215V21.049h3.7a3.9,3.9,0,0,0,3.472-1.661,9.218,9.218,0,0,0,1.123-5.1Q16.506,8.1,11.728,8.1ZM8.215-11.312V-.286h3.308a4,4,0,0,0,3.359-1.322,6.983,6.983,0,0,0,1.031-4.267q0-2.945-1.123-4.192A4.619,4.619,0,0,0,11.2-11.312Zm-5.7,41.047V-19.96H10.87q5.7,0,8.291,3t2.593,9.573A20.2,20.2,0,0,1,20.631-.1q-1.123,2.87-3.022,3.474v.34a6.6,6.6,0,0,1,3.666,3.889,21.1,21.1,0,0,1,1.154,7.7q0,6.835-2.665,10.63a8.358,8.358,0,0,1-7.2,3.8ZM37.009,8.1H33.5V21.049h3.7a3.9,3.9,0,0,0,3.472-1.661,9.218,9.218,0,0,0,1.123-5.1Q41.788,8.1,37.009,8.1ZM33.5-11.312V-.286H36.8a4,4,0,0,0,3.359-1.322A6.983,6.983,0,0,0,41.2-5.875q0-2.945-1.123-4.192a4.619,4.619,0,0,0-3.594-1.246ZM27.8,29.734V-19.96h8.352q5.7,0,8.291,3t2.593,9.573A20.2,20.2,0,0,1,45.913-.1q-1.123,2.87-3.022,3.474v.34a6.6,6.6,0,0,1,3.666,3.889,21.1,21.1,0,0,1,1.154,7.7q0,6.835-2.665,10.63a8.358,8.358,0,0,1-7.2,3.8Zm30.979,0h-5.7V-19.96h5.7ZM71.235,10.665V29.734h-5.7V-19.96h7.821q5.452,0,8.1,3.682T84.1-5.082a21.873,21.873,0,0,1-1.3,7.8A12.455,12.455,0,0,1,79.1,8.1Q85.162,24.825,87,29.734H80.669L74.257,10.665Zm0-21.977V2.093h1.838A4.72,4.72,0,0,0,77.055.432a8.44,8.44,0,0,0,1.287-5.173q0-3.512-1.3-5.041a5.08,5.08,0,0,0-4.094-1.529Z",
    transform: "translate(-17649 -7180)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle-tow",
    d: "M0,0H5A73,73,0,0,1,78,73H0Z",
    transform: "translate(-17640 -7283)",
    fill: "#f2dbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle-one",
    d: "M0,0H78V73H73A73,73,0,0,1,0,0Z",
    transform: "translate(-17736 -7200)",
    fill: "red"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e4a2208b3fcf2539fb7f9ebffdfa3149.svg";
export { ForwardRef as ReactComponent };